export default getText => key =>
  ({
    btnLabelClose: getText('Close', 'AVConsult_InfoBox'),
    messagingTitle: getText('Messaging', 'AVConsult_InfoBox'),
    infoTitle: getText('Patient Details', 'AVConsult_InfoBox'),
    infoTitle2: getText('Problem description', 'AVConsult_InfoBox'),
  }[key])
